export default "__VITE_ASSET__UbzA7zXt__"